import { render, staticRenderFns } from "./RecommendationLifetimeSummary.vue?vue&type=template&id=38ca2107"
import script from "./RecommendationLifetimeSummary.vue?vue&type=script&lang=js"
export * from "./RecommendationLifetimeSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports